<template>
    <calendar :view="view" :limit-months="limitMonths" :limit-events="limitEvents"></calendar>
</template>
<script>
    import { ref, inject, onMounted, computed } from "vue";
    import calendar from "@/components/webComponents/widget/calendar/calendar.vue";

    export default {
        components: {
            calendar
        },
        props: {
            view: {
                type: String,
                default: "calendar"
            },
            limitMonths: {
                type: String,
                default: "6"
            },
            limitEvents: {
                type: String,
                default: "10"
            }
        },
        setup(props, context) {
            return {}
        }
    }
</script>
